/* Winkelwagen-drawer (wens 115): de drawer opent niet-modaal, dus leggen we
   een onzichtbare laag over de pagina. Een klik daarop sluit alleen de
   drawer en opent verder niets op de pagina. */
(function () {
  function start() {
    var drawer = document.getElementById('cart-drawer');
    var dialog = drawer && drawer.querySelector('dialog');
    if (!dialog) return;
    var laag = document.createElement('div');
    laag.className = 'fts-wagen-laag';
    laag.hidden = true;
    document.body.appendChild(laag);
    laag.addEventListener('click', function () {
      if (typeof drawer.close === 'function') drawer.close();
      else dialog.close();
    });
    function bij() { laag.hidden = !dialog.open; }
    new MutationObserver(bij).observe(dialog, { attributes: true, attributeFilter: ['open'] });
    bij();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
